import { hotTopics, newsFeed, tagWall } from "@/mocks/home";

export default function NewsFeed() {
  return (
    <section id="feed" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6 lg:gap-8">
          <div>
            <div className="flex items-end justify-between gap-4 mb-6">
              <div>
                <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
                  <i className="ri-flashlight-line" />
                  Live Feed
                </span>
                <h2 className="mt-3 font-heading font-black text-3xl md:text-4xl text-foreground-950">
                  爆料速览
                </h2>
              </div>
              <span className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-md bg-background-100 border border-background-200 text-xs font-label text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500" />
                滚动更新中
              </span>
            </div>

            <div className="rounded-lg border border-background-200 overflow-hidden">
              {newsFeed.map((item, index) => (
                <a
                  key={item.id}
                  href="#feed"
                  className={`group flex items-center gap-4 px-4 md:px-5 py-4 hover:bg-primary-50 transition-colors ${
                    index !== 0 ? "border-t border-background-100" : ""
                  }`}
                >
                  <span className="w-16 shrink-0 font-mono text-sm text-foreground-500">
                    {item.time}
                  </span>
                  <span className="hidden sm:inline-flex shrink-0 items-center px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs font-label font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="flex-1 min-w-0 text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="shrink-0 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-label">
                      <i className="ri-fire-fill" />
                      热
                    </span>
                  )}
                  <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-600 transition-colors" />
                </a>
              ))}
            </div>

            <div className="mt-5 flex items-center justify-between gap-4 p-4 rounded-lg bg-background-100 border border-background-200">
              <p className="text-sm text-foreground-600">
                速览只放标题，点进去才是完整话题。喜欢就从上面入口板挑一条畅通的线路。
              </p>
              <a
                href="#entries"
                className="hidden md:inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-label font-medium hover:bg-foreground-900 transition-colors whitespace-nowrap"
              >
                去挑线路
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <aside className="flex flex-col gap-5">
            <div className="p-5 rounded-lg bg-background-100 border border-background-200">
              <div className="flex items-center gap-2">
                <i className="ri-price-tag-3-line text-primary-600 text-lg" />
                <h3 className="font-heading font-bold text-lg text-foreground-950">标签墙</h3>
              </div>
              <p className="mt-2 text-sm text-foreground-600">点标签换角度看，比干等更新有意思。</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {tagWall.map((tag) => (
                  <a
                    key={tag}
                    href="#topics"
                    className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors"
                  >
                    #{tag}
                  </a>
                ))}
              </div>
            </div>

            <div className="p-5 rounded-lg bg-foreground-950 border border-foreground-950">
              <div className="flex items-center gap-2">
                <i className="ri-bar-chart-2-line text-accent-400 text-lg" />
                <h3 className="font-heading font-bold text-lg text-background-50">本周热度榜</h3>
              </div>
              <div className="mt-4 flex flex-col">
                {hotTopics.map((topic, index) => (
                  <a
                    key={topic.id}
                    href="#topics"
                    className={`flex items-start gap-3 py-3 ${
                      index !== 0 ? "border-t border-background-50/10" : ""
                    }`}
                  >
                    <span
                      className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-label font-bold ${
                        index === 0
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-background-50/10 text-background-300"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm text-background-100 leading-snug line-clamp-2">
                        {topic.title}
                      </span>
                      <span className="mt-1 block text-xs text-background-400 font-label">
                        {topic.heat}
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}